import { map, mergeDeepRight } from 'ramda'

const pages =
  [
    /* 切片撒钱活动首页 */
    {
      path: 'activity/saqian',
      name: 'h5-saqian-activity',
      component: () => import(/* webpackChunkName: "h5-saqian-activity" */ '@/views/h5/activity/saqian/index.vue')
    },
    /* 切片撒钱活动细则页 */
    {
      path: 'activity/saqian-rules',
      name: 'h5-saqian-activity-specification',
      component: () =>
        import(/* webpackChunkName: "h5-saqian-activity-rules" */ '@/views/h5/activity/saqian/saqian-rules.vue')
    },
    /* 周小闹-切片撒钱活动首页 */
    {
      path: 'activity/saqian-zhouxiaonao',
      name: 'h5-saqian-zhouxiaonao-activity',
      component: () =>
        import(
          /* webpackChunkName: "h5-saqian-zhouxiaonao-activity" */ '@/views/h5/activity/saqian/zhouxiaonao-index.vue'
        )
    },
    /* 周小闹-切片撒钱活动细则页 */
    {
      path: 'activity/saqian-rules',
      name: 'h5-saqian-zhouxiaonao-activity-specification',
      component: () =>
        import(
          /* webpackChunkName: "h5-saqian-zhouxiaonao-activity-rules" */ '@/views/h5/activity/saqian/zhouxiaonao-rules.vue'
        )
    },
    /* 酒水切片月-活动首页 */
    {
      path: 'activity/jiushui',
      name: 'h5-jiushui-activity',
      component: () =>
        import(/* webpackChunkName: "h5-jiushui-activity" */ '@/views/h5/activity/saqian/jiushui/index.vue')
    },
    /* 酒水切片月-活动细则页 */
    {
      path: 'activity/jiushui-rules',
      name: 'h5-jiushui-activity-specification',
      component: () =>
        import(/* webpackChunkName: "h5-jiushui-activity-rules" */ '@/views/h5/activity/saqian/jiushui/rules.vue')
    }
  ] |> map(mergeDeepRight({ meta: { requireLogin: false, notShowDialog: true } }))

export default pages
